/* eslint-disable react/display-name */
import LoaderSkeleton from "component/loader-skeleton/LoaderSkeleton";
import useScreenSize from "hoc/useScreenSize";
import dynamic from "next/dynamic";
import { forwardRef } from "react";

const VehicleSelectorFormCompactDropdown = dynamic(() => import(/* webpackChunkName: "vehicle-selector-form-compact-dropdown" */ "./VehicleSelectorFormCompactDropdown"), {
  loading: () => (
    <LoaderSkeleton
      height={45}
      count={3}
      classNameContainer="loader-skeleton-vehicle-selector-modal loader-skeleton-vehicle-selector-inline"
    />
  ),
  ssr: false,
});

const VehicleSelectorFormRegular = dynamic(() => import(/* webpackChunkName: "vehicle-selector-form-regular" */ "./VehicleSelectorFormRegular"), {
  loading: () => (
    <LoaderSkeleton
      height={45}
      gridView
      count={3}
      classNameContainer="loader-skeleton-vehicle-selector-modal loader-skeleton-vehicle-selector-inline"
    />
  ),
  ssr: false,
});

const ForwardedRefVehicleSelectorFormRegular = forwardRef((_props: any, ref: any) => (
  <VehicleSelectorFormRegular {..._props} forwardedRef={ref} />
));

const ForwardedRefVehicleSelectorFormDropdown = forwardRef((_props: any, ref: any) => (
  <VehicleSelectorFormCompactDropdown {..._props} forwardedRef={ref} />
));

function VehicleSelectorRefForm(props) {
  const {
    vehicleSelectYearRef, vehicleSelectMakeRef, vehicleSelectModelRef, vehicleSelectEngineRef, vehicleSelectNextAttributeRef, vehicleSelectCompactRef,
    selectionOrder, category, state, handleFocus, handleSelect, focusEl, autoFocus, attributeTitle,
    required,
  } = props;

  const [, , isDesktop] = useScreenSize();

  if (isDesktop || attributeTitle) { // For fitment option show single long list like desktop
    return (
      <ForwardedRefVehicleSelectorFormRegular
        ref={{
          vehicleSelectYearRef,
          vehicleSelectMakeRef,
          vehicleSelectModelRef,
          vehicleSelectEngineRef,
          vehicleSelectNextAttributeRef,
        }}
        {...{
          selectionOrder,
          category,
          state,
          handleFocus,
          handleSelect,
          focusEl,
          autoFocus,
          attributeTitle,
          required,
        }}
      />
    );
  }

  return (
    <ForwardedRefVehicleSelectorFormDropdown
      ref={vehicleSelectCompactRef}
      {...{
        selectionOrder,
        category,
        state,
        handleFocus,
        handleSelect,
        focusEl,
        attributeTitle,
        required,
      }}
    />
  );
}

export default VehicleSelectorRefForm;
